export const numStringToCss = (value, units = 'px') => {
    if (typeof value === 'string') {
        return value;
    }
    return `${value}${units}`;
};
export const numBoolToCss = (value, equals, trueValue, falseValue = 0, units = 'px') => {
    if (typeof value === 'number')
        return `${value}${units}`;
    if (value === equals)
        return numStringToCss(trueValue, units);
    return numStringToCss(falseValue, units);
};
export const prop = (key) => (props) => props[key];
export const validateRGB = (color) => {
    const regex = /rgb(a)?\((\s*(\d|\.)+\s*,\s*){2}(\s*(\d|\.)+\s*){1}(\s*,\s*(\d|\.)+\s*)?\)/;
    return regex.test(color);
};
export const validateHex = (color) => {
    const regex = /#([0-9a-f]{3}|[0-9a-f]{6})$/;
    return regex.test(color);
};
export const stringToRGB = (color) => {
    if (color.startsWith('rgb') || color.startsWith('rgba')) {
        if (!validateRGB(color))
            return null;
        const openBrace = color.indexOf('(');
        const closeBrace = color.indexOf(')');
        const strs = color.slice(openBrace + 1, closeBrace).split(',');
        const nums = strs.map(s => parseFloat(s.trim()));
        return {
            R: nums[0],
            G: nums[1],
            B: nums[2],
            A: nums.length === 4 ? nums[3] : undefined
        };
    }
    if (color.startsWith('#')) {
        if (!validateHex(color))
            return null;
        let c;
        if (color.length === 4 && color[1] === color[2] && color[1] === color[3]) {
            c = color[1].repeat(6);
        }
        else if (color.length === 7) {
            c = color.slice(1);
        }
        else {
            return null;
        }
        return {
            R: parseInt(c.slice(0, 2), 16),
            G: parseInt(c.slice(2, 4), 16),
            B: parseInt(c.slice(4, 6), 16)
        };
    }
    return null;
};
export const contrastColor = (color, lightColor, darkColor) => {
    const rgb = stringToRGB(color);
    if (!rgb)
        return darkColor;
    return (((rgb.R * 0.299) + (rgb.G * 0.587) + (rgb.B * 0.114)) > 186) ? darkColor : lightColor;
};
